const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');


function parseActPwdAndRegId(item) {
  return {
    activationPassword: item.activationPassword,
    registrationId: item.registrationId
  }
}

function serviceFactory({ api }) {
  const getActPwdAndRegId = memoizer()((deviceCode, isNTB, authCode, metaData) =>
    api.getActPwdAndRegId(deviceCode, isNTB, authCode, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const generateServerEphPubKey = memoizer()((clientEphimeralPubKey, registrationID, deviceCode, metaData) =>
    api.generateServerEphPubKey(clientEphimeralPubKey, registrationID, deviceCode, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const generateServerEvidenceMessage = memoizer()((clientEvidenceMessage, registrationID, deviceCode, metaData) =>
    api.generateServerEvidenceMessage(clientEvidenceMessage, registrationID, deviceCode, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const activateDevice = memoizer()((deviceCode, deviceCodeTwoFactorValue, registrationID, isReinstallationFlag, metaData) =>
    api.activateDevice(deviceCode, deviceCodeTwoFactorValue, registrationID, isReinstallationFlag, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const verifyDeviceSignature = memoizer()((deviceCode, isNTB, signature, registrationID, metaData) =>
    api.verifyDeviceSignature(deviceCode, isNTB, signature, registrationID, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const verifyOTP = memoizer()((deviceCode, oneTimePassword, metaData) =>
    api.verifyOTP(deviceCode, oneTimePassword, metaData).then((response) => {
      if (!response) return null;
      var jsonResponse = response;
      if (response.returnCode == 1061) {
        jsonResponse.returnCode = -1; //Application backward compatability
        jsonResponse.retCode = 1061; //For new application and web code
      }
      return JSON.stringify(jsonResponse);
    }).catch((error) => {
      return null;
    })
  );

  const handleSecondFactorStatus = memoizer()((deviceCode, metaData) =>
    api.handleSecondFactorStatus(deviceCode, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const getSecondFactorAuthServerTime = memoizer()((metaData) =>
    api.getSecondFactorAuthServerTime(metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const setUserLoginAlias = memoizer()((metaData) =>
    api.setUserLoginAlias(metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const updateActivationStatus = memoizer()((deviceCode, isNTB, vascoStatus, isRegistrationSkipped, emailId, language, metaData) =>
    api.updateActivationStatus(deviceCode, isNTB, vascoStatus, isRegistrationSkipped, emailId, language, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const deactivateSecondFactor = memoizer()((deviceCode, forgetPinMessage, serialInstance, metaData) =>
    api.deactivateSecondFactor(deviceCode, forgetPinMessage, serialInstance, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const auditSecondfactorEventLog = memoizer()((deviceCode, logMessage, metaData) =>
    api.auditSecondfactorEventLog(deviceCode, logMessage, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const handleSecondFactorStatusAndAuthServerTime = memoizer()((deviceCode, serverTimeValue, metaData) =>
    api.handleSecondFactorStatusAndAuthServerTime(deviceCode, serverTimeValue, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const registerViaSMS = memoizer()((inputs, metaData) =>
    api.registerViaSMS(inputs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const validateSMSAuthCode = memoizer()((inputs, metaData) =>
    api.validateSMSAuthCode(inputs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const fetchSecondFactorStatusDetails = memoizer()((inputs, metaData) =>
    api.fetchSecondFactorStatusDetails(inputs, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const deactivateDevice = memoizer()((deviceCode, metaData) =>
    api.deactivateDevice(deviceCode, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  return {
    getActPwdAndRegId,
    generateServerEphPubKey,
    generateServerEvidenceMessage,
    activateDevice,
    verifyDeviceSignature,
    verifyOTP,
    handleSecondFactorStatus,
    getSecondFactorAuthServerTime,
    setUserLoginAlias,
    updateActivationStatus,
    deactivateSecondFactor,
    auditSecondfactorEventLog,
    handleSecondFactorStatusAndAuthServerTime,
    registerViaSMS,
    validateSMSAuthCode,
    fetchSecondFactorStatusDetails,
    deactivateDevice
  };

}

module.exports = serviceFactory;
